import * as React from 'react'

import { Text } from '@factorialco/deprecated-design-system'
import { PerformanceTargetAvatarFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { InlineEmployee } from 'modules/performance_v2/components/InlineEmployee'

export const TargetAvatar: React.FC<{
  access: PerformanceTargetAvatarFragment
}> = ({ access }) => {
  if (!access?.employeeName)
    return <Text.Normal>{i18n.t('performance_process.reviews.evaluations.unknown')}</Text.Normal>

  return <InlineEmployee employee={access.employeeName} />
}
